import { render, staticRenderFns } from "./CompaniesFilters.vue?vue&type=template&id=a4a96b64&scoped=true"
import script from "./CompaniesFilters.vue?vue&type=script&lang=js"
export * from "./CompaniesFilters.vue?vue&type=script&lang=js"
import style0 from "./CompaniesFilters.vue?vue&type=style&index=0&id=a4a96b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a96b64",
  null
  
)

export default component.exports